import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'reverse',
    pure: false
})
export class ReversePipe implements PipeTransform {

    transform(values: any) {
        return values.reverse();
    }
}


// WEBPACK FOOTER //
// ./angularApp/app/pipes/reverse.pipe.ts